/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { keyframes } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'

/** Charge, tax and total — the money rows of the preview it stands in for. */
const MONEY_ROWS = 3

// SECONDARY_350 (the house skeleton bar) is absent from the typed appColors
// inference, so it is read through a cast — the pattern PlayerFormSkeleton set.
const palette = colors as Record<string, string>

/**
 * Stands in for the Add Invoice preview while the server prices the charge: the
 * three money rows, then the due-date and new-share lines, so the modal does not
 * jump when the figures land.
 */
const AddInvoicePreviewSkeleton = () => (
  <div
    css={containerStyle}
    data-testid='add-invoice-preview-skeleton'
    aria-hidden='true'
  >
    {Array.from({ length: MONEY_ROWS }).map((_, row) => (
      <div key={row} css={moneyRowStyle}>
        <div css={labelBarStyle} />
        <div css={valueBarStyle} />
      </div>
    ))}
    <div css={lineBarStyle} />
    <div css={shortLineBarStyle} />
  </div>
)

export default AddInvoicePreviewSkeleton

const pulse = keyframes`
  0% { opacity: 0.5; }
  50% { opacity: 0.9; }
  100% { opacity: 0.5; }
`

const bar = css`
  border-radius: 8px;
  background-color: ${palette.SECONDARY_350};
  animation: ${pulse} 1.4s ease-in-out infinite;
`

const containerStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const moneyRowStyle = css`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`

const labelBarStyle = css`
  ${bar}
  height: 16px;
  width: 96px;
`

const valueBarStyle = css`
  ${bar}
  height: 16px;
  width: 72px;
`

const lineBarStyle = css`
  ${bar}
  height: 16px;
  width: 60%;
`

const shortLineBarStyle = css`
  ${bar}
  height: 16px;
  width: 40%;
`
